import { render, staticRenderFns } from "./Offers-by-category.vue?vue&type=template&id=d120efa2&"
import script from "./Offers-by-category.vue?vue&type=script&lang=js&"
export * from "./Offers-by-category.vue?vue&type=script&lang=js&"
import style0 from "./Offers-by-category.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports